import { Box, type SxProps, type Theme } from "@mui/material";
import type { FC, ReactNode } from "react";
import { HALLOWEEN } from "@/theme/tokens";

type Props = {
	children: ReactNode;
	/** Whether the hat shows. The wrapper renders either way, so the logo's layout never shifts. */
	decorated: boolean;
	/** Width of the square mark at the logo's left edge, as a share of the whole logo's width (1 = the logo is only the mark). */
	markWidthRatio: number;
	sx?: SxProps<Theme>;
	dataTestId?: string;
};

/** A tilted witch hat sitting on a logo's mark. Scales with the logo, so one component fits every logo size. */
export const SeasonalLogoHat: FC<Props> = ({ children, decorated, markWidthRatio, sx, dataTestId }) => (
	<Box data-testid={dataTestId} sx={[{ position: "relative", display: "inline-flex", lineHeight: 0 }, ...(Array.isArray(sx) ? sx : [sx])]}>
		{children}
		{decorated && (
			<Box aria-hidden sx={{ position: "absolute", left: 0, top: 0, height: "100%", width: `${markWidthRatio * 100}%`, pointerEvents: "none" }}>
				<Box
					component="svg"
					viewBox="0 0 30 26"
					data-testid={dataTestId && `${dataTestId}-hat`}
					sx={{ position: "absolute", left: "38%", top: "-44%", width: "74%", height: "auto", transform: "rotate(14deg)", overflow: "visible" }}
				>
					<path d="M15 1 C12 6 9 13 8 19 L22 19 C20 14 18 9 23 6 C19 5 17 3 15 1 Z" fill={HALLOWEEN.HAT} stroke={HALLOWEEN.HAT_EDGE} strokeWidth={0.8} />
					<path d="M8.5 16.5 L21.5 16.5 L21.8 18.6 L8.2 18.6 Z" fill={HALLOWEEN.PUMPKIN} />
					<ellipse cx={15} cy={20.5} rx={14} ry={3.2} fill={HALLOWEEN.HAT} stroke={HALLOWEEN.HAT_EDGE} strokeWidth={0.8} />
				</Box>
			</Box>
		)}
	</Box>
);
